<template>
    <div class="page_header">
        <div class="title">
            <div class="menu">{{ $t(headerData.menu) }}</div>
            <div class="desc">{{ $t(headerData.menu_desc) }}</div>
        </div>
        
        <div class="week">
            <div class="week_num">
                <img :src="small_logo" alt="" width="30">
                Week {{ headerData.week }}
            </div>
            <div class="current_time">Current Time {{ headerData.current_time }}</div>
        </div>

        <div class="admin_email">
            <a-popconfirm placement="bottom" :showCancel="false" @confirm="confirm">
                <template #title>{{ $t('base.email') }}</template>
                <template #description>
                    <div class="email_text" v-for="(item,index) in admin_email" :key="index">
                        <MailOutlined style="color: #aaa; margin: 0 5px 0 -20px;"/> {{ item }}
                    </div>
                </template>
                <img class="profile" src="@/assets/image/profile.png" alt="" width="30" height="30">
                <span class="email_title">{{ $t('account.adminAccountEmail') }}</span>
            </a-popconfirm>
        </div>
    </div>
</template>

<script setup>
    import {onMounted, reactive, ref, watch} from 'vue';
    import { useRoute, useRouter } from 'vue-router'
    import { HomeApi } from '@/api/HomeApi.js';
    import { message } from 'ant-design-vue';
    import { MailOutlined } from '@ant-design/icons-vue';

    const props = defineProps({
        headerData:{
            type:Object,
            default:()=>{},
        },
    })

    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const small_logo = ref('')
    const admin_email = ref([])


    const getAdminEmail = async ()=>{
        let res = await HomeApi.getInstance().getAdminEmail(userInfo.value.tenant_id)
        if(res.code === 0){
            admin_email.value = res.data
        }else{
            message.error(res.msg || res.message)
        }
    }
    
    // const route = useRoute()
    // const router = useRouter()
    // const menu = ref('')
    // const menu_desc = ref('')
    // const routeData = ref([])

    // const getBreadcrumb = ()=>{
    //     let data = route.matched.filter(item=>item.name !== 'Index' && item.meta)
    //     return data[0]
    // }

    // watch(() => router.path,(val) => {
    //     console.log(val, 'path')
    //     // menu.value = route.meta.lang
    //     // menu_desc.value = route.meta.menuDesc
    // })

    onMounted(()=>{
        // routeData.value = getBreadcrumb()
        // console.log(routeData.value,'routeData')
        // menu.value = routeData.value.meta.lang
        // menu_desc.value = routeData.value.meta.menuDesc
        
        // console.log(menu.value,'menu')

        if(sessionStorage.getItem('logo')){
            small_logo.value = JSON.parse(sessionStorage.getItem('logo')).small_logo
        }

        getAdminEmail()

    })
</script>

<style lang="scss" scoped>
.page_header{
    padding: 10px 0px 20px 0px;
    margin-left: -10px;

    .title{
        // display: flex;
        margin-left: 10px;
        span{
            height: 20px;
            line-height: 50px;
        }

        .menu{
            margin-right: 20px;
            font-weight: 700;
            font-size: 37px;
            color: #1226AA;

        }

        .desc{
            margin-top: -5px;
            font-size: 15px;
            font-weight: 500;
            color: #555;
        }
    }

    .admin_email{
        float: right;
        margin-top: -60px;
        margin-right: 200px;
        cursor: pointer;

        .email_title{
            margin-left: 10px;
            color: #1226AA;
            font-weight: 700;
            font-size: 15px;
        }

        .email_text{
            margin-left: 40px;
            padding: 5px 0;
        }
    }

    .week{
        float: right;
        margin-top: -70px;
        color: #5469D4;
        
        .week_num{
            font-size: 23px;
            font-weight: 500;
        }

        .current_time{
            font-size: 12px;
            font-weight: 700;
            
        }
    }
}

</style>